import { useSearchParams } from '@remix-run/react'

export const useUrlQueries = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const getUrlQuery = (propName: string) => {
    return searchParams.get(propName)
  }

  const unsetUrlQuery = (propNames: string[]) => {
    propNames.forEach((propName) => searchParams.delete(propName))
  }

  const setUrlQuery = (newQuery: Record<string, string>[]) => {
    newQuery.forEach((query) => {
      for (const [key, value] of Object.entries(query)) {
        searchParams.set(key, value)
      }
    })
  }

  const submitSearchParams = () => {
    setSearchParams(searchParams, { preventScrollReset: true })
  }

  return { getUrlQuery, setUrlQuery, unsetUrlQuery, submitSearchParams }
}
